import { Card } from "@caprikorn/dynamo-ui";
import { type FC, useId } from "react";

import classes from "./AccessManagerCard.module.css";
import type { AccessManagerCardProps } from "./AccessManagerCard.types";

export const AccessManagerCard: FC<AccessManagerCardProps> = ({
  title,
  children,
  subtitle,
  dataTestId = "card-access-manager",
  pictoWithToolTip,
}) => {
  const titleId = useId();
  return (
    <Card
      aria-labelledby={titleId}
      as="section"
      className={classes.container}
      data-testid={dataTestId}
      size="lg"
    >
      <div className={classes.row}>
        <h1 className="font-title-md" id={titleId}>
          {title}
        </h1>
        {pictoWithToolTip}
      </div>
      {subtitle && <p>{subtitle}</p>}
      <div className={classes.content}>{children}</div>
    </Card>
  );
};
